import React, { useRef } from "react";
import { BsFileEarmarkArrowDownFill } from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";
import "../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const DownloadButton = ({ id, typeDocument}) => {
  const downloadLinkRef = useRef(null);

  const handlerdowload = async (e) => {
    e.preventDefault();
    try {
      // Realiza una solicitud GET al servidor para obtener el archivo y su tipo
      const response = await axios.get(
        `${process.env.REACT_APP_LEALTAD_ABM_OF_DOCUMENT_GET}?id=${id}`,
        { responseType: "arraybuffer" }
      );

      // Verifica que la respuesta sea exitosa (código de estado 200)
      if (response.status === 200) {
        // Obtiene el tipo de archivo del encabezado de respuesta
        let contentType = response.headers["content-type"];

        // Elimina cualquier parte adicional después del primer punto y coma (;)
        contentType = contentType.split(";")[0];

        // Obtén el tipo de archivo (extensión) a partir del tipo de contenido
        const fileExtension = contentType.split("/")[1]; // Esto obtiene la extensión, por ejemplo, "jpeg" de "image/jpeg"

        // Define el nombre del archivo
        const fileName = `${typeDocument}.${fileExtension}`;

        // Crea un blob con los datos del archivo
        const blob = new Blob([response.data], { type: contentType });

        // Crea un objeto URL para el blob
        const fileUrl = window.URL.createObjectURL(blob);

        // Crea un enlace para descargar el archivo
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;

        // Simula un clic en el enlace para iniciar la descarga
        a.click();

        // Libera el objeto URL creado
        window.URL.revokeObjectURL(fileUrl);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error al obtener el archivo del servidor",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de enviar el documento.",
      });
    }
  };

  return (
    <button
      className="button_abm-lealtad"
      type="button"
      onClick={(e) => handlerdowload(e)}
      ref={downloadLinkRef}
    >
      <i className="fa fa-refresh-lealtad"></i>
      <BsFileEarmarkArrowDownFill className="icon-list-lealtad" />
    </button>
  );
};

export default DownloadButton;